var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_419_13686)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.7483 10.5576C19.8688 10.2216 20.3499 10.2216 20.4705 10.5576L20.8001 11.4764C20.8387 11.5839 20.9244 11.6686 21.0333 11.7067L21.9636 12.0322C22.3038 12.1513 22.3038 12.6265 21.9636 12.7455L21.0333 13.0711C20.9244 13.1092 20.8387 13.1938 20.8001 13.3014L20.4705 14.2202C20.3499 14.5562 19.8688 14.5562 19.7483 14.2202L19.4186 13.3014C19.38 13.1938 19.2944 13.1092 19.1855 13.0711L18.2552 12.7455C17.9149 12.6265 17.9149 12.1513 18.2552 12.0322L19.1855 11.7067C19.2944 11.6686 19.38 11.5839 19.4186 11.4764L19.7483 10.5576Z",
    fill: "#060200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3843 14.6402C23.4646 14.4162 23.7854 14.4162 23.8657 14.6402L24.0855 15.2528C24.1112 15.3245 24.1683 15.3809 24.2409 15.4063L24.8611 15.6233C25.088 15.7027 25.088 16.0195 24.8611 16.0989L24.2409 16.3159C24.1683 16.3413 24.1112 16.3977 24.0855 16.4694L23.8657 17.082C23.7854 17.306 23.4646 17.306 23.3843 17.082L23.1645 16.4694C23.1388 16.3977 23.0817 16.3413 23.0091 16.3159L22.3889 16.0989C22.162 16.0195 22.162 15.7027 22.3889 15.6233L23.0091 15.4063C23.0817 15.3809 23.1388 15.3245 23.1645 15.2528L23.3843 14.6402Z",
    fill: "#060200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2116 5.1148C25.3861 4.6284 26.0826 4.6284 26.2571 5.1148L26.8552 6.78188C26.9111 6.93758 27.0351 7.06006 27.1927 7.11523L28.8806 7.70594C29.3731 7.87829 29.3731 8.56616 28.8806 8.73851L27.1927 9.32921C27.0351 9.38438 26.9111 9.50686 26.8552 9.66256L26.2571 11.3296C26.0826 11.816 25.3861 11.816 25.2116 11.3296L24.6135 9.66256C24.5577 9.50686 24.4337 9.38438 24.276 9.32921L22.5881 8.73851C22.0956 8.56616 22.0956 7.87829 22.5881 7.70594L24.276 7.11523C24.4337 7.06006 24.5577 6.93758 24.6135 6.78188L25.2116 5.1148Z",
    fill: "#060200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.75 17.8246C6.75 23.0301 11.0927 27.25 16.4498 27.25C20.5738 27.25 24.0968 24.7491 25.5 21.2229C24.3887 21.7301 23.1477 22.0136 21.8386 22.0136C17.0768 22.0136 13.2165 18.2626 13.2165 13.6355C13.2165 11.7003 13.8917 9.91839 15.0257 8.5C10.3438 9.16937 6.75 13.0892 6.75 17.8246Z",
    stroke: "#060200",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_419_13686",
    x: -3,
    y: -3,
    width: 42,
    height: 42,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.172549 0 0 0 0 0.611765 0 0 0 0 1 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_419_13686"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_419_13686",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoon);
export default __webpack_public_path__ + "static/media/Moon.6e96878fa17afe4c1d4a866cbc76ceac.svg";
export { ForwardRef as ReactComponent };